import { render, staticRenderFns } from "./PdvProductBarcodeSearch.vue?vue&type=template&id=0c430744"
import script from "./PdvProductBarcodeSearch.vue?vue&type=script&lang=js"
export * from "./PdvProductBarcodeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports